import React from 'react'
import { PreviewContainer,Paragraph } from './styledComponents'

const Preview = ({ formData }) => {
  return (
    
    
      <PreviewContainer>
        <Paragraph>
          Dear Hiring Manager, <br /><br />
          My name is {formData.name} and I’m applying for the role of {formData.role}.
          <br /><br />
          {formData.skills}
          <br /><br />
          Looking forward to discussing further.<br />
          Sincerely, <br />
          {formData.name}
        </Paragraph>
      </PreviewContainer>
    
  )
}

export default Preview
